import React, { useState, useEffect } from "react";
import "./ServiceSection.css";

const ServiceSection = () => {

    const services = [
        {
            id: 0,
            title: "Access To <br /> Inner Circle",
            description: "Unlock private access to my core strategies, tools, and trader ecosystem.",
            position: { top: "15%", left: "15%" },
            image: './assets/service_image.png'
        },
        {
            id: 1,
            title: "Live Market Updates",
            description: "Stay ahead with real-time insights, setups & scanner-based alerts.",
            position: { top: "45%", right: "20%" },
            image: './assets/service_image.png'

        },
        {
            id: 2,
            title: "Early Access To Our Products",
            description: "Be the first to access unreleased systems, upgrades, and high-performance tools.",
            position: { bottom: "15%", left: "15%" },
            image: './assets/service_image.png'

        }
    ];



    return (
        <section id="services" className="services-section-home ">
            <div className="container">
                <div className="services-content">
                    <h2 className="services-title text-center text-white animate-on-scroll">
                        Here's what you <span>unlock with me...</span>
                    </h2>

                    <div className="services-interactive">
                        {/* Main phone image container */}
                        {/* <div className="services-image-container">
                            <img
                                src="./assets/service_image.png"
                                alt="Services Interface"
                                className="services-main-image"
                            />
                        </div> */}

                        <div className="services-cards-home">

                            <div className="service-card-home">
                                <div className="service-content">
                                    <h3 className="title-text" dangerouslySetInnerHTML={{ __html: services[0].title }}></h3>
                                    <p className="description-text">{services[0].description}.</p>
                                </div>
                                <div className="service-image-container">
                                    <img
                                        src={services[0].image}
                                        alt="Services Interface"
                                        className="services-main-image"
                                    />
                                </div>
                            </div>


                            <div className="service-card-home">
                                <div className="service-image-container">
                                    <img
                                        src={services[1].image}
                                        alt="Services Interface"
                                        className="services-main-image"
                                    />
                                </div>
                                <div className="service-content">
                                    <h3 className="title-text">{services[1].title}</h3>
                                    <p className="description-text">{services[1].description}.</p>
                                </div>

                            </div>



                            <div className="service-card-home">
                                <div className="service-content">
                                    <h3 className="title-text" dangerouslySetInnerHTML={{ __html: services[2].title }}></h3>
                                    <p className="description-text">{services[2].description}.</p>
                                </div>
                                <div className="service-image-container">
                                    <img
                                        src={services[2].image}
                                        alt="Services Interface"
                                        className="services-main-image"
                                    />
                                </div>
                            </div>

                            {services.map((service, index) => (
                                <div className="service-card-home-mobile">

                                    <div className="service-image-container">
                                        <img
                                            src={service.image}
                                            alt="Services Interface"
                                            className="services-main-image"
                                        />
                                    </div>
                                    <div className="service-content">
                                        <h3 className="title-text" dangerouslySetInnerHTML={{ __html: service.title }}></h3>
                                        <p className="description-text">{service.description}.</p>
                                    </div>
                                </div>
                            ))}



                        </div>

                        {/* Interactive service cards */}
                        {/* <div className="services-cards">
                            {services.map((service, index) => (
                                <div
                                    key={service.id}
                                    className={`service-card-home ${activeCard === index ? 'active' : ''}`}
                                    style={service.position}
                                    onClick={() => setActiveCard(index)}
                                >
                                    <div className="service-content">
                                        <h3 className="service-title">{service.title}</h3>
                                        <p className="service-description">{service.description}</p>
                                    </div>

                                   
                                    <div className="connection-line"></div>
                                </div>
                            ))}
                        </div> */}

                        {/* Interactive dots/indicators */}
                        {/* <div className="services-indicators">
                            {services.map((_, index) => (
                                <button
                                    key={index}
                                    className={`indicator ${activeCard === index ? 'active' : ''}`}
                                    onClick={() => setActiveCard(index)}
                                />
                            ))}
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;